import { CatalogItem } from '@nrdy-marketing-engine/cart/@types/catalog-item';
import { useCallback, useEffect, useState } from 'react';
import { CartState, Client } from '../../@types/cart-state';
import useOnCreateAccount from './use-on-create-account';
import useOnSignIn from './use-on-sign-in';
import useInsensitiveSearchParams from './use-insensitive-search-params';

interface UseAccountStepProps {
  catalogItem: CatalogItem;
  onContinue: (newState: CartState) => void;
  setError: (field: string, opts: any) => void;
}

function useAccountStep({ onContinue, setError, catalogItem }: UseAccountStepProps) {
  const urlSignIn = useInsensitiveSearchParams().get('sign_in');
  const [signInForm, setSignInForm] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (urlSignIn === 'true') {
      setSignInForm(true);
    }
  }, []);

  const onSwitchForm = useCallback(() => setSignInForm(!signInForm), [signInForm]);

  const onCreateAccount = useOnCreateAccount({
    onContinue,
    onSwitchForm,
    setError,
    setLoading,
  });

  const onSignIn = useOnSignIn({ setLoading, setError, onContinue });

  const onSubmit = useCallback(
    (client: Client, leadId: string) => {
      if (loading) return;
      if (!signInForm) {
        return onCreateAccount(leadId ? { ...client, lead_uuid: leadId } : client);
      }
      return onSignIn(client);
    },
    [signInForm, onSignIn, onCreateAccount, loading]
  );

  return {
    loading,
    onSubmit,
    onSwitchForm,
    signInForm,
  };
}

export default useAccountStep;
